var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8v112.6c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2 72.8-15 127.8-79.6 127.8-156.8v-155.4c0-11.4-8.1-21.3-19.3-23.5l-62.9-12.6c-13-2.6-25.6 5.8-28.2 18.8l-3.2 15.7c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96v-122.5l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7c-2.6-13-15.2-21.4-28.2-18.8l-62.8 12.4c-11.2 2.3-19.3 12.1-19.3 23.6v155.4c0 77.3 55.1 142 128.1 156.8 2.6 90.4 80.5 163.2 175.9 163.2 97 0 176-75.4 176-168v-112.6c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCare);
export default __webpack_public_path__ + "static/media/HealthCare.51a9d3217ad76668d48651e6225dab2b.svg";
export { ForwardRef as ReactComponent };